import React from "react";
import styled from "styled-components";
import { useContext } from "react";
import { useAboutStore } from "../AboutStore";

const Wrapper = styled.div`
  background-color: black;
  width: 100vw;
  height: 5.5vh;
  position: absolute;
  bottom: 0;
`;

const Title = styled.p`
  position: absolute;
  width: min-content;
  text-align: justify;
  left: 0;
  bottom: -10px;
  margin: 0;
  color: white;
  font-size: 35pt;
  font-family: Roumald;
  cursor: pointer;
`;

const Date = styled.p`
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 0;
  bottom: -10px;

  color: white;
  font-size: 35pt;
  font-family: Roumald;
  cursor: pointer;
`;

export default function Header() {
  const { aboutOpen } = useAboutStore();
  const swap = useAboutStore((state) => state.swap);

  return (
    <div>
      <Wrapper>
        <Title onClick={swap}>nina</Title>
        <Date onClick={swap}>kunzendorf</Date>
        {/* <Date onClick={swap}>2025</Date> */}
      </Wrapper>
    </div>
  );
}
